module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="horizontal-slider-inner js-horizontal-slider-inner">\n';
 _.each(rounds, function(round, index) { 
__p+='\n	<div class="item js-item '+
((__t=( _.result(round, 'id') == selected ? 'active' : '' ))==null?'':_.escape(__t))+
'"\n	     data-index="'+
((__t=( index + 1 ))==null?'':_.escape(__t))+
'"\n	     data-id="'+
((__t=( _.result(round, 'id') ))==null?'':_.escape(__t))+
'">\n		Round '+
((__t=( _.result(round, 'id') ))==null?'':_.escape(__t))+
'\n	</div>\n';
 }) 
__p+='\n</div>';
}
return __p;
};
